import { ASSET_TYPES } from '@/shared/api/openmetadata';

/**
 * 실험 관련 자산 타입 상수
 */
export const EXPERIMENT_RELATED_TYPES = [
  'project',
  'experiment',
  'run',
  'dataset',
  'run_dataset',
  'feature_set',
  'run_feature_set',
  'parameter_set',
  'run_parameter_set',
  'artifact',
  'run_artifact',
] as const;

/**
 * Run 하위 자산 타입 상수
 */
export const RUN_RELATED_TYPES = [
  'run',
  'dataset',
  'run_dataset',
  'feature_set',
  'run_feature_set',
  'parameter_set',
  'run_parameter_set',
  'artifact',
  'run_artifact',
] as const;

/**
 * Run의 서브 자산 타입 상수 (assetType 쿼리 파라미터가 필요한 타입)
 */
export const RUN_SUB_ASSET_TYPES = [
  'dataset',
  'run_dataset',
  'feature_set',
  'run_feature_set',
  'parameter_set',
  'run_parameter_set',
  'artifact',
  'run_artifact',
] as const;

/**
 * 데이터 탐색(통합 검색 페이지)에서 결과·필터·URL에 포함하지 않는 OM entityType 목록
 * (예: 통합 검색에서 숨김 처리하는 타입 및 openmetadata 검색 필터 통합 관리용)
 */
export const DISCOVERY_SEARCH_EXCLUDED_ASSET_TYPES = [
  ASSET_TYPES.MLMODEL,
  'parameter_set',
  'run_parameter_set',
] as const;

export const isExcludedFromDiscoveryAssetTypeFilter = (type: string): boolean =>
  DISCOVERY_SEARCH_EXCLUDED_ASSET_TYPES.includes(type as (typeof DISCOVERY_SEARCH_EXCLUDED_ASSET_TYPES)[number]);

export type ExperimentRelatedType = (typeof EXPERIMENT_RELATED_TYPES)[number];
export type RunRelatedType = (typeof RUN_RELATED_TYPES)[number];

/**
 * 주어진 타입이 실험 관련 타입인지 확인
 */
export const isExperimentRelatedType = (type: string): boolean => {
  return EXPERIMENT_RELATED_TYPES.includes(type as ExperimentRelatedType);
};

/**
 * 주어진 타입이 Run 하위 자산 타입인지 확인
 */
export const isRunRelatedType = (type: string): boolean => {
  return RUN_RELATED_TYPES.includes(type as RunRelatedType);
};
